import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { AppHeader } from "../../components/header/header";
import { AppFooter } from "../../components/footer/footer";
import "../../styles/placement.css";
import { Biodata } from "../../components/placement/biodata";
import { PageButton } from "./prev-next";
import { CompetencyBox } from "../../components/placement/competencies";
import { useAuth } from "../../services/authentication/authentication.context";
import { aiConversation } from "../../services/authentication/authentication.services";
import { LoadingIndicator } from "../../components/utilities/loader";
import { useLesson } from "../../services/lessons/lessons.context";
import { Recommendation } from "../../components/placement/recomendation";
import classNames from "classnames";
import { AppAlert } from "../../components/utilities/app-alert";

export const PlacementPage = () => {

    const { token } = useAuth();
    const { courses, placeLearner } = useLesson();

    const navigateTo = useNavigate();

    const [testQuestions, setTestQuestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [bioData, setBiodata] = useState({
        agegroup: '10 to 14',
        gender: 'Male'
    });

    const [competencies, setCompetencies] = useState({
        mathSkill: 0,
        creativity: 0,
        science: 0
    })
    const [indx, setIndx] = useState(1);
    const [answers, setAnswers] = useState({});
    const [onAlert, setOnAlert] = useState();

    const [remmendedations, setRecommendations] = useState([]);


    const requestData = {
        content: `Create 20 STEM placement MCQ questions, five in each of the follwing fields: Maths, Physics, Science, and Critical thinking; for young learners between the ages of ${bioData.agegroup}. The questions must be in the form of a json array for example [{ "question": "What is the result of 3 + 5 * 2?", "options": [ "16", "13", "10", "11" ], "answer": "1" }]. The answer should be the array index of the correct option`
    }


    const toPrevPage = async (e) => {
        e.preventDefault();
        setIndx(i => i - 1);
        if (indx === 3) {
            setLoading(true);
            const qData = await getPalcementQuestions(requestData, token);
            setTestQuestions(qData);
            setLoading(false);
        }
    }

    const toNextPage = async (e) => {
        e.preventDefault();
        setIndx(i => i + 1);
        if (indx === 1) {
            setLoading(true);
            const qData = await getPalcementQuestions(requestData, token);
            setTestQuestions(qData);
            setLoading(false);
        }

        if (indx === 2) {
            setLoading(true);
            const promtText = await createAnswerPrompt();
            //console.log(promtText);
            const rData = await getRecommendation({ content: promtText }, token);
            console.log(rData);
            setRecommendations(rData);
            setLoading(false);

        }
    }

    const handleChangeAge = (e) => {
        setBiodata((data) => ({ ...data, agegroup: e.target.value }))
    }

    const handleChangeGender = (e) => {
        setBiodata((data) => ({ ...data, gender: e.target.value }))
    }

    const handleUpdateValue = (e) => {
        setCompetencies((data) => ({ ...data, [e.target.name]: e.target.value }));
    }

    const extractJsonArray = (inputString) => {
        const regex = /\[\s*\{[^]*?\}\s*\]/;
        const match = inputString.match(regex);
        if (match) {
            const arrayString = match[0];
            return JSON.parse(arrayString);
        } else {
            return false
        }
    }

    const getPalcementQuestions = async (data, token) => {
        try {
            const response = await aiConversation(data, token);
            const res = await response.json();
            const resString = res?.message;
            return extractJsonArray(resString);

        } catch (error) {
            console.log(error);
        }
    }

    const getRecommendation = async (data, token) => {
        try {
            const response = await aiConversation(data, token);
            const res = await response.json();
            console.log({ res });
            const resString = res?.message;
            return extractJsonArray(resString);
        } catch (error) {
            console.log({ error });
        }
    }

    const createAnswerPrompt = async () => {
        const answerValues = Object.values(answers);
        const answeredQsuestions = testQuestions?.map((question, index) => ({ ...question, givenAnswer: answerValues[index] }));
        const answerPrompt = `Give a recommendation for the for the most suitable STEM course or courses that the student might take based of results from the test which is in the following array: ${JSON.stringify(answeredQsuestions)}. -  The object property givenAnswer is the array index to the answer options array, 
        - The answer property is the correct answer to the question. The recomendation should be in a json array of the form: [{recommendedCourse: ### course name ###, reason: ## a brief explanation on why the course is recommended ##, courseData: ### -- course data json object, as given in the prompt ###}]
        - The available courses are in the array ${JSON.stringify(courses)}`;
        return answerPrompt;
    }

    const completePlacement = async (e) => {
        e.preventDefault();
        setLoading(true);
        const resp = await placeLearner(token);
        setLoading(false);
        if (resp?.error) {
            setOnAlert({
                caption: "Error",
                message: resp?.error,
                accept: "Ok",
                onAccept: () => {
                    setOnAlert();
                },
                onClose: () => setOnAlert()
            })
            return;
        }
        setOnAlert({
            caption: "Success",
            message: resp?.message,
            accept: "Ok",
            onAccept: () => {
                setOnAlert();
                navigateTo("/courses");
            },
            onClose: () => setOnAlert()
        })
    }



    return (
        <div className="flx-v">
            <AppHeader />
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAccept={onAlert.onAccept}
                    closeAlert={onAlert.onClose}
                />
            )}
            {loading && <LoadingIndicator />}
            {indx === 1 &&
                <div className={classNames("cap", 'md-txt', "rec-txt")}>
                    Sorry for bringing you here. We recommend that you take a short placement test, and let our AI assistant recommend the best courses for you, based on your performance.
                </div>
            }
            <div className="pl-frm-container">

                <form className="pl-frm">
                    {indx === 1 &&
                        <div className="rec-box">
                            <div className={classNames("cap", 'lg-txt')}>
                                Personal data
                            </div>
                            <Biodata
                                setAgegroup={handleChangeAge}
                                setGender={handleChangeGender}
                                bioData={bioData}
                            />
                        </div>
                    }
                    {indx === 2 &&
                        <div className="rec-box">
                            <div className={classNames("cap", 'md-txt')}>
                                Endeavour to attemp every question. Good luck!
                            </div>
                            <CompetencyBox
                                mathskill={competencies.mathSkill}
                                creativity={competencies.creativity}
                                science={competencies.science}
                                changeValue={handleUpdateValue}
                                testQuestions={testQuestions}
                                passAnswer={(v) => setAnswers(v)}
                            />
                        </div>
                    }
                    {indx === 3 &&
                        <div className="rec-box">
                            <div className={classNames("cap", 'md-txt')}>
                                Here are some recommendations, for courses you might consider taking, based on our assessment:
                            </div>
                            <Recommendation
                                data={remmendedations}
                            />
                        </div>
                    }
                    <PageButton
                        toPrevPage={toPrevPage}
                        toNextPage={toNextPage}
                        handlePlace={completePlacement}
                        indx={indx}
                    />
                </form>
            </div>
            <AppFooter />
        </div>
    );
}